import React, { useState, useMemo } from "react";
import { Router, Redirect, RouteComponentProps } from "@reach/router";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Container, Typography } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import LoginSelection from "./LoginSelection";
import LoginResource from "../../../resources/LoginResource";
import { useResource } from "rest-hooks";
import LoginError from "./LoginError";
import { Header } from "../../sections/header/Header";
import { MyPagePanel } from "../../common";
import { headerHeight, headerHeightMobile } from "../../../constants";
import { Alert } from "@material-ui/lab";
import { FormattedMessage } from "react-intl";
import TestLogin from "./TestLogin";

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		flexGrow: 1,
		marginTop: headerHeight,
		[theme.breakpoints.down("sm")]: {
			marginTop: headerHeightMobile,
		},
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "center",
		color: theme.palette.text.secondary,
	},
	options: {
		paddingTop: theme.spacing(5),
	},
}));

interface ILoginProps extends RouteComponentProps { }

const Login = (props: ILoginProps) => {
	const { location } = props;
	const classes = useStyles();

	const { isAuthenticated } = useResource(LoginResource.detailShape(), {});

	const [allowTestLogin, setAllowTestLogin] = useState(false);
	useMemo(async () => {
		const res = await fetch("/api/settings/SimpleTestLogin", {
			method: "GET",
		});
		setAllowTestLogin(await res.json());
	}, []);

	if (isAuthenticated) return null;

	return (
		<>
			<Header />
			<MyPagePanel className={classes.root}>
				<Container maxWidth="sm">
					{(location?.state as any)?.errorCode === 401 && (
						<Alert severity="error" style={{ marginBottom: 15 }}>
							<FormattedMessage
								id="minside.login.unauthorized"
								defaultMessage="Din sesjon har utløpt. Vennligst logg inn på nytt"
								description="Error message whenn the session has expired"
							/>
						</Alert>
					)}
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography
								component="h1"
								variant="h2"
								align="center"
								gutterBottom
							>
								<LockIcon fontSize="inherit" />
							</Typography>
						</Grid>
					</Grid>
				</Container>
				<Router>
					<LoginSelection path="/" allowTestLogin={allowTestLogin} />
					{/*<BankIdLogin*/}
					{/*	iframeUrl={bankIdIframeUrl}*/}
					{/*	type="standard"*/}
					{/*	path="bankid"*/}
					{/*/>*/}
					{/*<BankIdLogin*/}
					{/*	iframeUrl={bankIdMobileIframeUrl}*/}
					{/*	type="mobile"*/}
					{/*	path="bankid-mobile"*/}
					{/*/>*/}
					{allowTestLogin && <TestLogin path="ssn" />}
					<LoginError path="/login-error" />
				</Router>
			</MyPagePanel>
		</>
	);
};

export default Login;
